import React, { useEffect, useState } from 'react';
import './faculty-ui.css';

export default function Toast({ type = 'success', text, message }) {
  const content = text || message;
  const [visible, setVisible] = useState(!!content);

  useEffect(() => {
    if (content) {
      setVisible(true);
      const timer = setTimeout(() => setVisible(false), 4000);
      return () => clearTimeout(timer);
    }
  }, [content]);

  if (!content || !visible) return null;
  return <div className={`ui-toast ${type}`}>{content}</div>;
}
